import { AddressBookBackup, useAddressBookStore } from '@/store/addressBook';

export default function useBackupExport() {
  const store = useAddressBookStore();

  const prepareBackup = (): AddressBookBackup => {
    return {
      items: store.items,
      bundles: store.bundles,
      createdAt: Date.now(),
    };
  };

  return { prepareBackup };
}
